import styled from "styled-components";

export default styled.div`
  background: ${({ theme: { colors } }) => colors.ellipse_3};
  box-shadow: 4px 18px 27px rgba(78, 100, 236, 0.08);
  border-radius: 15px;
  padding: 30px 15px;
  height: 100%;

  .status-details-container {
    display: flex;
    gap: 25px;
    > div {
      :first-child {
        flex: 1 1 192px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
        .status-details {
          display: flex;
          flex-direction: column;
          gap: 5px;
          span {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 15px;
            color: #6d7d97;
          }
          h3 {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 21px;
            color: ${({ theme: { colors } }) => colors.ellipse_20};
          }
          &.border-bottom {
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid
              ${({ theme: { colors } }) => colors.ellipse_25};
          }
          @media screen and (max-width: 769px) {
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
            span {
              font-size: 14px;
            }
          }
        }
      }
      :last-child {
        flex: 1 1 294px;
        display: flex;
        flex-direction: column;
        gap: 13px;
        .status-box {
          align-items: center;
          padding: 7px;
          background: #163193;
          border-radius: 10px;
          min-height: 79px;
          display: flex;
          gap: 18px;
          :nth-of-type(1) {
            background: ${({ theme: { colors } }) => colors.ellipse_17};
          }
          :nth-of-type(2) {
            background: ${({ theme: { colors } }) => colors.ellipse_18};
          }
          :nth-of-type(3) {
            background: ${({ theme: { colors } }) => colors.ellipse_19};
          }
          .lock-icon {
            display: grid;
            place-items: center;
            width: 64px;
            height: 64px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 5px;
          }
          > div:not(.lock-icon) {
            display: flex;
            flex-direction: column;
            gap: 5px;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 15px;
            color: rgba(255, 255, 255, 0.5);
            h3 {
              font-weight: 500;
              font-size: 14px;
              line-height: 21px;
              color: #ffffff;
            }
          }

          @media screen and (max-width: 769px) {
            background: unset !important;
            gap: 10px !important;
            padding: 0 !important;
            > div {
              border-radius: 15px;
            }
            > div:not(.lock-icon) {
              width: 100%;
              justify-content: center;
              align-items: flex-start;
              padding: 7px;
              padding-inline-start: 2rem;
              background: #163193;
              border-radius: 10px;
              min-height: 79px;
            }
            .lock-icon {
              height: 100%;
              border-radius: 10px;
              width: 85px;
            }
            :nth-of-type(1) {
              > div:not(.lock-icon),
              .lock-icon {
                background: ${({ theme: { colors } }) => colors.ellipse_17};
              }
            }
            :nth-of-type(2) {
              > div:not(.lock-icon),
              .lock-icon {
                background: ${({ theme: { colors } }) => colors.ellipse_18};
              }
            }
            :nth-of-type(3) {
              > div:not(.lock-icon),
              .lock-icon {
                background: ${({ theme: { colors } }) => colors.ellipse_19};
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 991px) {
      flex-wrap: wrap;
    }
  }
  .progress-bar-container {
    width: 100%;
    .progress-bar {
      margin-top: 25px;
      background: ${({ theme: { colors } }) => colors.ellipse_21};
      border-radius: 22.832px;
      width: 100%;
      div {
        background: ${({ theme: { colors } }) => colors.ellipse_22};
        border-radius: 22.832px;
        height: 7px;
        width: 0%;
      }
    }
    span {
      font-style: normal;
      font-weight: 400;
      font-size: 8.5px;
      line-height: 13px;
      color: #6d7d97;
    }
  }
  .footer-actions {
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    > div {
      flex: 1 1 245px;
      :first-child {
        display: flex;
        flex-direction: column;
        gap: 11px;
        .un-stake {
          cursor: pointer;
          color: #ffffff;
          padding: 6px 0;
          border: 0;
          height: 32px;
          background: #723cc2;
          border-radius: 6px;
          :hover {
            background: #481d88;
          }
          &:disabled {
            pointer-events: none;
            cursor: default;
            background: rgba(88, 112, 158, 1);
          }
        }
      }
      :last-child {
        align-self: self-end;
      }
    }
  }
  @media screen and (max-width: 769px) {
    padding: unset;
    background: unset;
    box-shadow: unset;
    .status-details-container {
      flex-direction: column;
      > div {
        :first-child {
          border-radius: 15px;
          background: ${({ theme: { colors } }) => colors.ellipse_31};
          padding: 30px 15px;
          border: 1px solid ${({ theme: { colors } }) => colors.ellipse_6};
        }
      }
    }
    .progress-bar-container .progress-bar {
      margin-top: 0;
    }
  }
`;
